import { InjectedComponent, InjectedComponentSet, styled } from '@topwrite/common';
import Markdown from './markdown';
import { ComponentProps } from 'react';
import useArticle from '@/lib/use-article';
import useFile from '@/lib/use-file';

interface ArticleProps extends Omit<ComponentProps<typeof Markdown>, 'children' | 'as'> {
    className?: string;
}

export default function Article({ className, header, footer, ...props }: ArticleProps) {

    const file = useFile();
    const article = useArticle();

    if (header === undefined && article) {
        header = <Title>{article.title}</Title>;
    }

    header = <>
        <InjectedComponentSet role={'page:article:before'} />
        {header}
    </>;

    footer = <>
        {footer}
        <InjectedComponentSet role={'page:article:after'} />
    </>;

    const children = <InjectedComponent
        role={'page:article:markdown'}
        component={Markdown}
        props={{
            header,
            footer,
            children: file.content,
            ...props
        }}
    />;

    return <div className={className}>
        {children}
    </div>;
}

const Title = styled.h1`
  border-bottom: 1px solid #eee;
  font-size: 2em;
  line-height: 1.2;
  padding: 0 0 .5em;
  margin: 0 0 1em;
  font-weight: 400;
`;
